module.exports = __webpack_public_path__ + "img/p93.0dab4bde.jpg";